const { default: APIConstants, PMS_APIs } = require('src/configs/API')
const { default: request } = require('src/utils/request')
import { captureMessage  } from '@sentry/react';

const insertContact = ({ name, phone, email, content }) => {
	return request.v4Api({
		url: APIConstants.API_INSERT_CONTACT,
		data: {
			Name: name,
			Status: false,
			Phone: phone,
			Email: email,
			Content: content,
		},
		method: 'POST',
	})
}
const insertContactPushtoBiz = ({ name, phone, email, content }) => {
	return request.v4Api({
		url: APIConstants.API_INSERT_CONTACT_PUSH_TO_BIZ,
		data: {
			Name: name,
			Status: false,
			Phone: phone,
			Email: email,
			Content: '',
			Address: content,
		},
		method: 'POST',
	})
}
const insertContactPushtoCRMLead = ({ name, phone, email, content, formId, buttonId, provinceId, wardId }, headers) => {
	    captureMessage(`Inserted contact ${name} ${phone} ${provinceId} ${wardId} Browser: ${navigator.userAgent} to CRM lead`);
	return request.pmsApi({
		url: PMS_APIs.API_CREATE_CRM_LEAD,
		data: {
			ContactName: name,
			ContactPhone: phone,
			ContactEmail: email,
			CustomerAddress: content,
			LeadSourceApp: 'WebKH',
			ButtonId: buttonId,
			FormId: formId,
			ProvinceId: provinceId,
			WardId: wardId
		},
		method: 'POST',
		headers
	})
}

const insertPriceContact = (value) => {
	return request.v4Api({
		url: APIConstants.API_INSERT_PRICE_CONTACT,
		data: value,
		method: 'POST',
	})
}

const contactServices = {
	insertContact,
	insertPriceContact,
	insertContactPushtoBiz,
	insertContactPushtoCRMLead
}

export default contactServices
